import { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FlowTrasitionType } from "./types";

export default function FlowTransition({
  pages,
  firstPage,
  isOpen,
  indexPage,
}: FlowTrasitionType) {
  const [history, setHistory] = useState([firstPage, indexPage ?? null]);
  const [animationLeft, setAnimationLeft] = useState(false);
  const [animationRight, setAnimationRight] = useState(false);
  const [value, ...previousValues] = history;

  const undo = useCallback(() => {
    setAnimationRight(true);
    setTimeout(() => {
      setHistory(previousValues);
      setAnimationRight(false);
    }, 300);
  }, [setHistory, previousValues]);

  const setValue = useCallback(
    (newValue: string) => {
      setAnimationLeft(true);
      setTimeout(() => {
        setHistory([newValue, ...history]);
        setAnimationLeft(false);
      }, 300);
    },
    [history, setHistory]
  );
  useEffect(() => {
    if (value !== firstPage) setValue(firstPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const Page = pages[value as any];
  return (
    <div className={styles.flowTransitionContent}>
      <div
        className={`${styles.activePage} ${animationLeft && styles.left} ${
          animationRight && styles.right
        }`}
      >
        <Page next={setValue} back={undo} />
      </div>
    </div>
  );
}
